import { TourStep } from '@/hooks/useTour';

/**
 * Factory function to create tour steps with tab activation callbacks
 * @param setActiveTab Callback to set the active tab in ResourceCompliancePage
 */
export const createResourceComplianceTourSteps = (setActiveTab?: (tab: string) => void): TourStep[] => [
  {
    id: 'welcome-banner',
    target: '[data-tour-id="page-container"]',
    title: 'M365 Resource Health',
    content: 'This dashboard helps show how we are keeping track of our data in Microsoft 365. This is our first snapshot or starting point.',
    position: 'center',
    action: () => setActiveTab?.('overview'),
  },
  {
    id: 'metadata-intro',
    target: '[data-tour-id="page-container"]',
    title: 'What are we tracking?',
    content: 'All Microsoft 365 resources (SharePoint sites, Teams, and Outlook Groups) need: Primary Owner, Secondary Owner, Business Unit, and Cost Center.',
    position: 'center',
  },
  {
    id: 'overview-intro',
    target: '[data-tour-id="overview-section"]',
    title: 'Organization Overview',
    content: 'This is where we\'re starting from - just over 50%. We average 2 out of 4 for each resource - Primary Owner, Secondary Owner, Business Unit, Cost Center.',
    position: 'center',
    action: () => setActiveTab?.('overview'),
  },
  {
    id: 'business-unit-summary',
    target: '[data-tour-id="business-unit-summary"]',
    //  target: '[data-tour-id="page-container"]',
    title: 'BU Summary',
    content: 'The BU Summary shows how each business unit is doing (and how many resources are Unknown).',
    position: 'center',
    action: () => setActiveTab?.('bu'),
  },
  {
    id: 'my-groups-list',
    //  target: '[data-tour-id="org-all-resources"]',
    target: '[data-tour-id="page-container"]',
    title: 'My Resources',
    content: 'These are all Microsoft 365 resources we think you own and if we think it\'s healthy or missing info.',
    position: 'center',
    action: () => setActiveTab?.('myresources'),
  },
  {
    id: 'update-metadata',
    //  target: '[data-tour-id="update-metadata-cta"]',
    target: '[data-tour-id="page-container"]',
    title: 'Updating Metadata',
    content: 'Instructions will be sent out to help update missing fields to improve our next resource health score.',
    position: 'center',
    action: () => setActiveTab?.('myresources'),
  },
  {
    id: 'compliance-score',
    target: '[data-tour-id="compliance-score"]',
    title: 'Your Health Score',
    content: 'If your score is above 80%, you are healthy (green). Leaders will have their health and their recursive health, with everyone that reports to them.',
    position: 'center',
    action: () => setActiveTab?.('org'),
  },
  {
    id: 'org-structure-intro',
    target: '[data-tour-id="org-structure-summary"]',
    title: 'My Organization',
    content: 'Individual contributors will see their own health metrics. Leaders will see a summary of their team\'s health metrics.',
    position: 'center',
    action: () => setActiveTab?.('org'),
  },
  {
    id: 'org-recursive-score',
    //  target: '[data-tour-id="org-recursive-score"]',
    target: '[data-tour-id="org-structure-section"]',
    title: 'Resource Health Is Recursive',
    content: 'Your health score impacts your Leader\'s score and everyone adds up to the Organization\'s score.',
    position: 'center',
    action: () => setActiveTab?.('org'),
  },
//   {
//     id: 'org-resources',
//     target: '[data-tour-id="org-all-resources"]',
//     title: 'All Organizational Groups',
//     content: 'View every group in your organization. Identify which ones need metadata updates.',
//     position: 'bottom',
//   },
  {
    id: 'next-steps',
    target: '[data-tour-id="page-container"]',
    title: 'You are all set!',
    content: 'This is our first snapshot. Regular updates will help us keep our data healthy. Click "Need Help?" for FAQs and to submit a question.',
    position: 'center',
    action: () => setActiveTab?.('overview'),
  },
];

// Export with default empty callback for backwards compatibility
export const RESOURCE_COMPLIANCE_FIRST_TIME_TOUR = createResourceComplianceTourSteps();
